import React from 'react'
import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { useFormContext } from 'react-hook-form'
import { UserFormData } from 'redux/actions/admin'

interface ModalFooterProps {
  isLoading: boolean
  onSubmit: (data: any) => void
  buttonText?: string
}

export const ModalFooter: React.FC<ModalFooterProps> = ({ isLoading, onSubmit, buttonText }) => {
  const formContext = useFormContext<UserFormData>()
  const theme = useSelector((state: RootState) => state.general.theme)

  const handleClick = formContext ? formContext.handleSubmit(onSubmit) : () => onSubmit({})

  return (
    <NoFocusButton
      bg={theme?.elementsColor}
      fontSize={{ base: '12px', md: '14px' }}
      px="10px"
      py="10px"
      minW="100px"
      type="submit"
      color="white"
      isLoading={isLoading}
      isDisabled={isLoading}
      onClick={handleClick}
    >
      {buttonText}
    </NoFocusButton>
  )
}
